<template>
  <l-modal
    :title="t('tabs.shipment-completed')"
    :button-text="t('tabs.close')"
    @close="$emit('close')"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { LModal } from '@last/core-ui/paprika'

defineEmits(['close'])

const { t } = useI18n()
</script>
